import { css } from '@emotion/css';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/features';
import { OwnedPoint, OwnedPointProps } from './OwnedPoint';

export const OwnedPointHead: React.FC = () => {
  const pointState = useSelector((state: RootState) => state.fortune.point);
  const displayedPoint = useSelector((state: RootState) => state.fortune.displayedPoint);
  const previous = useRef<number | null>(null);
  const [ownedPointProps, setOwnedPointProps] = useState<OwnedPointProps>();
  useEffect(() => {
    const curr = displayedPoint ?? null;
    const prev = previous.current ?? null;
    if (curr !== null) {
      if (prev !== null && prev !== curr) {
        setOwnedPointProps({ start: prev, end: curr });
      } else {
        setOwnedPointProps({ end: curr });
      }
    } else {
      setOwnedPointProps(undefined);
    }
    previous.current = displayedPoint ?? null;
  }, [displayedPoint, previous]);

  if (pointState?.state === 'error') {
    return null;
  }

  return (
    <div
      className={css`
        display: flex;
        justify-content: center;
        height: 64px;
        background: #e0f4ba;
        padding: 0 0 4px;
      `}
    >
      {ownedPointProps ? <OwnedPoint {...ownedPointProps} /> : null}
    </div>
  );
};
